export class Form {
    schema() {
        return [
            {
                'component': 'h2',
                'children': 'Standort Beschreibung',
            },
            {
                'component': 'div',
                'class': 'row',
                'children': [
                    {
                        'type': 'text',
                        'name': 'headline',
                        'label': 'Überschrift',
                        'class': 'col-12',
                        'placeholder': 'Bitte eine Überschrift eingeben...',
                        'validation': 'min:5,length|required',
                        'validation-name': 'Überschrift',
                    },
                    {
                        'type': 'editor',
                        'name': 'description',
                        'label': 'Beschreibung',
                        'class': 'col-12',
                        'validation': 'min:5,length|required',
                        'validation-name': 'Beschreibung',
                    },
                ],
            },
        ];

    }
}
